import { GridItem } from '@bnnvara/grids';
import React from 'react';

import Comments from '../components/Comments';

const ComposableComments = (props) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
  >
    <Comments {...props} />
  </GridItem>
);

export default ComposableComments;
